/**
 * Admin — Skills page — /admin/skills
 *
 * See AdminNav for the full list of admin sections.
 */
import React from 'react';
import { SkillsEditor } from '@/components/admin/SkillsEditor';
import { AdminPageShell } from '../_components/AdminPageShell';

export const AdminSkillsPage: React.FC = () => (
  <AdminPageShell title="Skills">
    <SkillsEditor />
  </AdminPageShell>
);
